import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class NewsletterMailinglistService {
  /**
   * Newsletter Mailing Lists base url
   * @type {string}
   */
  private url: string = 'newsletter_mailinglists';

  /**
   * Inject dependencies
   * @param {HttpClientService} private httpClient Service for http calls
   */
  constructor(private httpClient: HttpClientService) {}

  /**
   * Add contact to newsletter mailing list
   * @param  {number}       id        Newsletter mailing list id
   * @param  {number}       contactId Contact id
   * @return {Promise<any>}           Server response
   */
  addContact(id: number, contactId: number): Promise<any> {
    return this.httpClient.post(`${this.url}/${id}/addcontact.json`, { contact_id: contactId });
  }

  /**
   * Newletter Mailing lists by contact or all
   * @param  {any}          params Filter params
   * @return {Promise<any>}        List of newsletter mailing lists
   */
  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }

  /**
   * Remove a contact from newsletter mailing lists
   * @param  {number}       id        Newsletter mailing list id
   * @param  {number}       contactId Contact id
   * @return {Promise<any>}           Server response
   */
  removeContact(id: number, contactId: number): Promise<any> {
    return this.httpClient.post(`${this.url}/${id}/removecontact.json`, { contact_id: contactId });
  }
}
